export enum WithdrawStep {
  Form = 'form',
  UserPaymentDetails = 'payment-details',
  Confirmation = 'confirmation',
  ConfirmationCode = 'confirmation-code',
  Response = 'response',
}
